// /dashboard/:orgSlug/analytics/coupling — the graph views (PRD 16 §5), plus
// the two full-canvas readings of the same data: the concept x document matrix
// (X4) and the corpus packing (X3).
//
// THIS IS THE AXIS THAT NEEDED THE CORPUS FIX. Every panel here reads corpus
// data, and every one of them was being asked for a corpus named after the org
// — which for `acme` does not exist. `?corpus=` is therefore load-bearing on
// this route rather than cosmetic, and `CorpusPicker.tsx` carries the story.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { AnalyticsScreen } from "../screens/analytics/AnalyticsScreen";
import {
  DEFAULT_RANGE,
  isRangeDays,
  type RangeDays,
} from "../screens/analytics/RangeChips";

type CouplingSearch = { days: RangeDays; corpus?: string };

export const analyticsCouplingRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/dashboard/$orgSlug/analytics/coupling",
  staticData: { title: "Analytics · Coupling" },
  validateSearch: (search: Record<string, unknown>): CouplingSearch => {
    const raw = Number(search.days);
    return {
      days: isRangeDays(raw) ? raw : DEFAULT_RANGE,
      corpus: typeof search.corpus === "string" ? search.corpus : undefined,
    };
  },
  component: AnalyticsCouplingRoute,
});

function AnalyticsCouplingRoute() {
  const { orgSlug } = analyticsCouplingRoute.useParams();
  const search = analyticsCouplingRoute.useSearch();
  const navigate = analyticsCouplingRoute.useNavigate();

  return (
    <AnalyticsScreen
      orgSlug={orgSlug}
      axis="coupling"
      days={search.days}
      corpus={search.corpus}
      onRangeChange={(days) =>
        navigate({ search: (prev: CouplingSearch) => ({ ...prev, days }) })
      }
      onCorpusChange={(corpus) =>
        navigate({ search: (prev: CouplingSearch) => ({ ...prev, corpus }) })
      }
    />
  );
}
